// Order tag vocabulary: color enum + chip/swatch classes. Presentation only,
// used by real-API tag screens and the MSW tag fixtures alike (moved out of
// mocks/data/settings.ts, OPT-20261031-05).

export type TagColor =
  | 'amber'
  | 'emerald'
  | 'sky'
  | 'rose'
  | 'violet'
  | 'orange'
  | 'slate'
  | 'pink'
  | 'cyan'
  | 'lime'

export type TagScope = 'admin' | 'seller' | 'supply' | 'all'

export type TagSetting = {
  id: string
  label: string
  color: TagColor
  scope: TagScope
  usage_count: number
  created_at: string
  created_by: string
}

// ---------------------------------------------------------------------------
// Color metadata — UI swatch + badge presentation.
// Each entry is presentation-only; schema commit Stage 4 SPEC.md Faz 6.
// ---------------------------------------------------------------------------

export const TAG_COLORS: TagColor[] = [
  'amber',
  'emerald',
  'sky',
  'rose',
  'violet',
  'orange',
  'slate',
  'pink',
  'cyan',
  'lime',
]

export const TAG_COLOR_CLASSES: Record<
  TagColor,
  { swatch: string; chip: string; ring: string }
> = {
  amber: {
    swatch: 'bg-amber-400',
    chip: 'bg-amber-100 text-amber-800 ring-amber-200',
    ring: 'ring-amber-300',
  },
  emerald: {
    swatch: 'bg-emerald-500',
    chip: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
    ring: 'ring-emerald-300',
  },
  sky: {
    swatch: 'bg-sky-500',
    chip: 'bg-sky-100 text-sky-800 ring-sky-200',
    ring: 'ring-sky-300',
  },
  rose: {
    swatch: 'bg-rose-500',
    chip: 'bg-rose-100 text-rose-800 ring-rose-200',
    ring: 'ring-rose-300',
  },
  violet: {
    swatch: 'bg-violet-500',
    chip: 'bg-violet-100 text-violet-800 ring-violet-200',
    ring: 'ring-violet-300',
  },
  orange: {
    swatch: 'bg-orange-500',
    chip: 'bg-orange-100 text-orange-800 ring-orange-200',
    ring: 'ring-orange-300',
  },
  slate: {
    swatch: 'bg-slate-500',
    chip: 'bg-slate-100 text-slate-800 ring-slate-200',
    ring: 'ring-slate-300',
  },
  pink: {
    swatch: 'bg-pink-500',
    chip: 'bg-pink-100 text-pink-800 ring-pink-200',
    ring: 'ring-pink-300',
  },
  cyan: {
    swatch: 'bg-cyan-500',
    chip: 'bg-cyan-100 text-cyan-800 ring-cyan-200',
    ring: 'ring-cyan-300',
  },
  lime: {
    swatch: 'bg-lime-500',
    chip: 'bg-lime-100 text-lime-800 ring-lime-200',
    ring: 'ring-lime-300',
  },
}
